import { PROJECT_TRACKER_FILTERS_UPDATED } from '../core/action-types'

export const updateFilters = (filters) => {
  return { type: PROJECT_TRACKER_FILTERS_UPDATED, payload: filters }
}
